import { render, staticRenderFns } from "./AppDialogAutorizar.vue?vue&type=template&id=486a8df2"
import script from "./AppDialogAutorizar.vue?vue&type=script&lang=js"
export * from "./AppDialogAutorizar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports